import {
  ACTUAL_COUNT__COLDEF,
  durationVF,
  NUM_FLOPPTIONS_BTN_MODAL__COLDEF,
  NUM_PASSENGERS__COLDEF,
  OG_TARGET_FARE_COLDEF,
  ONEWAY__CARRIER_0,
  ONEWAY__CARRIER_1,
  ONEWAY__CARRIER_2,
  ONEWAY__DEST,
  ONEWAY__FLIGHTNO_0,
  ONEWAY__FLIGHTNO_1,
  ONEWAY__FLIGHTNO_2,
  ONEWAY__ORIG,
  ONEWAY__PINNED_LEG__COLDEF,
  ONEWAY__STOP_0,
  ONEWAY__STOP_1,
  PINNED_TRIPID__COLDEF,
  PLANNER__COLDEF,
  ROUNDTRIP_F1__CARRIER_0,
  ROUNDTRIP_F1__CARRIER_1,
  ROUNDTRIP_F1__CARRIER_2,
  ROUNDTRIP_F1__DEST,
  ROUNDTRIP_F1__FLIGHTNO_0,
  ROUNDTRIP_F1__FLIGHTNO_1,
  ROUNDTRIP_F1__FLIGHTNO_2,
  ROUNDTRIP_F1__ORIG,
  ROUNDTRIP_F1__STOP_0,
  ROUNDTRIP_F1__STOP_1,
  ROUNDTRIP_F2__CARRIER_0,
  ROUNDTRIP_F2__CARRIER_1,
  ROUNDTRIP_F2__CARRIER_2,
  ROUNDTRIP_F2__DEST,
  ROUNDTRIP_F2__FLIGHTNO_0,
  ROUNDTRIP_F2__FLIGHTNO_1,
  ROUNDTRIP_F2__FLIGHTNO_2,
  ROUNDTRIP_F2__ORIG,
  ROUNDTRIP_F2__STOP_0,
  ROUNDTRIP_F2__STOP_1,
  XCA__SALES__COLDEF,
  XCA__TCC__COLDEF,
} from "./common-coldefs";
import { useMemo } from "react";
import { useAppMode, useItinMode } from "../store/model-misc";
import {
  filterToColdefsForAppmode,
  filterToColdefsForItinmode,
} from "./saxecap-dev-coldefs";

export function useColDefs(tableName) {
  const appMode = useAppMode();
  const itinMode = useItinMode();
  return useMemo(() => {
    let colDefs = [...DEFAULT_COL_DEFS];
    if (tableName === "dead_opps") {
      colDefs = [
        PINNED_TRIPID__COLDEF,
        ONEWAY__PINNED_LEG__COLDEF,
        PLANNER__COLDEF,
        XCA__TCC__COLDEF,
        XCA__SALES__COLDEF,
        ...colDefs,
        NUM_FLOPPTIONS_BTN_MODAL__COLDEF,
      ];
    }
    const appModeFilter = (cd) => filterToColdefsForAppmode(cd, appMode);
    const itinModeFilter = (cd) => filterToColdefsForItinmode(cd, itinMode);
    return colDefs.filter(appModeFilter).filter(itinModeFilter);
  }, [tableName, appMode, itinMode]);
}

const DEFAULT_COL_DEFS = [
  {
    headerName: "Total Savings",
    field: "Total Savings",
    type: "moneyColumn",
  },
  {
    headerName: "Trip Dead",
    field: "trip_dead",
    type: "booleanColumn",
  },
  {
    headerName: "Trip <37 Days Away",
    field: "trip__too_soon",
    type: "booleanColumn",
  },
  {
    headerName: "Trip: Fatal Action",
    field: "trip__fatal_action_report",
    type: "textColumn",
  },
  {
    headerName: "Trip-Leg Dead",
    field: "tripleg_dead",
    type: "booleanColumn",
  },
  {
    headerName: "Trip-Leg: Fatal Action",
    field: "tripleg__fatal_action_report",
    type: "textColumn",
  },
  {
    headerName: "Flight Dead",
    field: "flight_dead",
    type: "booleanColumn",
  },
  {
    headerName: "Flopption Dead",
    field: "flopption_dead",
    type: "booleanColumn",
  },
  {
    headerName: "Flopption: Wrong Departure Airport",
    field: "flopption__wrong_departure_airport",
    type: "booleanColumn",
  },
  {
    headerName: "Flopption: Wrong Arrival Airport",
    field: "flopption__wrong_arrival_airport",
    type: "booleanColumn",
  },
  {
    headerName: "Flopption: Fatal Action",
    field: "flopption__fatal_action_report",
    type: "categoryColumn",
  },
  {
    headerName: "Flopption: Should be Nonstop",
    field: "flopption__should_be_nonstop",
    type: "booleanColumn",
  },
  {
    headerName: "Flopption: Dallas + Kelli + Layover",
    field: "flopption__dallas_kelli_with_stop",
    type: "booleanColumn",
  },
  {
    headerName: "Flopption: Booked for Another Group",
    field: "flight__booked_for_another_group",
    type: "booleanColumn",
  },
  {
    headerName: "Flopption: Higher Fare than Booked",
    field: "flopption__not_lower_fare",
    type: "booleanColumn",
  },
  {
    headerName: "Departs At",
    field: "departs_at",
    type: "timestampColumn",
  },
  {
    headerName: "Days Until Departs",
    field: "days_until_departs",
    type: "integerColumn",
  },
  {
    headerName: "Opp Fare",
    field: "fare",
    type: "moneyColumn",
  },
  {
    headerName: "Fare Scaling",
    field: "flopption__fare_scaling",
    type: "floatColumn",
  },
  {
    headerName: "Util Penalty",
    field: "flopption__util_penalty",
    type: "moneyColumn",
  },
  {
    headerName: "Effective Fare",
    field: "flopption__effective_opp_fare",
    type: "moneyColumn",
  },
  {
    headerName: "Fare to Beat",
    field: "flopption__fare_to_beat",
    type: "moneyColumn",
  },
  OG_TARGET_FARE_COLDEF,
  {
    headerName: "Current Avg Fare",
    field: "Current Avg Fare",
    type: "moneyColumn",
  },

  ONEWAY__CARRIER_0,
  ROUNDTRIP_F1__CARRIER_0,
  ROUNDTRIP_F2__CARRIER_0,

  ONEWAY__FLIGHTNO_0,
  ROUNDTRIP_F1__FLIGHTNO_0,
  ROUNDTRIP_F2__FLIGHTNO_0,

  {
    headerName: "Fare Savings",
    field: "Fare Savings",
    type: "moneyColumn",
  },
  NUM_PASSENGERS__COLDEF,
  {
    headerName: "Est Cnt",
    field: "Est Cnt",
    type: "integerColumn",
  },
  ACTUAL_COUNT__COLDEF,

  // {
  //   headerName: "Google",
  //   field: "Google Flights URL",
  //   type: "urlColumn"
  // },
  // {
  //   headerName: "Kayak",
  //   field: "Kayak URL",
  //   type: "urlColumn"
  // },
  {
    headerName: "Type",
    field: "Budget Tour Type",
    type: "categoryColumn",
    __appMode: "dvy",
  },
  ONEWAY__ORIG,
  ROUNDTRIP_F1__ORIG,
  ROUNDTRIP_F2__ORIG,
  ONEWAY__DEST,
  ROUNDTRIP_F1__DEST,
  ROUNDTRIP_F2__DEST,
  {
    headerName: "Arrives At",
    field: "arrives_at",
    type: "timestampColumn",
  },
  {
    // TODO: Fix text alignment in cell
    // TODO: Fix filter
    headerName: "Trip Duration",
    field: "duration",
    type: "integerColumn",
    valueFormatter: durationVF,
  },
  ONEWAY__STOP_0,
  ROUNDTRIP_F1__STOP_0,
  ROUNDTRIP_F2__STOP_0,
  ONEWAY__CARRIER_1,
  ROUNDTRIP_F1__CARRIER_1,
  ROUNDTRIP_F2__CARRIER_1,
  ONEWAY__FLIGHTNO_1,
  ROUNDTRIP_F1__FLIGHTNO_1,
  ROUNDTRIP_F2__FLIGHTNO_1,
  ONEWAY__STOP_1,
  ROUNDTRIP_F1__STOP_1,
  ROUNDTRIP_F2__STOP_1,
  ONEWAY__CARRIER_2,
  ROUNDTRIP_F1__CARRIER_2,
  ROUNDTRIP_F2__CARRIER_2,
  ONEWAY__FLIGHTNO_2,
  ROUNDTRIP_F1__FLIGHTNO_2,
  ROUNDTRIP_F2__FLIGHTNO_2,
  {
    headerName: "Group#",
    field: "[Book] Group#",
    type: "textColumn",
    __appMode: "dvy",
  },
  {
    headerName: "Tour#",
    field: "[Book] Tour#",
    type: "integerColumn",
    __appMode: "dvy",
  },
  {
    headerName: "School",
    field: "[Book] School",
    type: "textColumn",
    __appMode: "dvy",
  },
  {
    headerName: "A/P",
    field: "A/P",
    type: "categoryColumn",
    __appMode: "dvy",
  },
  {
    headerName: "% Savings",
    field: "% Fare Savings",
    type: "floatColumn",
  },
];
